const SDK_VERSION = '7.50.0';

export { SDK_VERSION };
